const acRepairService = {
  title: "AC Repair",
  icon: "❄️",
  shortDescription:
    "AC check, cleaning, cooling issue diagnosis, installation, and service support.",
  longDescription:
    "Book air-conditioner service support for inspection, cleaning, installation, gas-related diagnosis, and cooling issue review. Final pricing may vary by model and fault condition.",
  consultationNote:
    "Gas refill, compressor issues, and internal component faults require inspection before final quote.",
  responsePromise:
    "Platform attempts fast structured assignment with backend fallback if technician reallocation is needed.",
  warrantyPolicy:
    "Warranty or revisit terms depend on service type, parts, and repair scope.",
  subServices: [
    {
      id: "ac-general-service",
      title: "AC General Service",
      icon: "🧼",
      group: "Service",
      description:
        "Basic AC cleaning and performance check for standard use maintenance.",
      basePrice: 499,
      priceType: "fixed",
      duration: "45-75 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "ac-deep-cleaning",
      title: "AC Deep Cleaning",
      icon: "💨",
      group: "Service",
      description:
        "Deep unit cleaning for better airflow and dust removal performance.",
      basePrice: 799,
      priceType: "starts_at",
      duration: "60-90 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "ac-not-cooling",
      title: "AC Not Cooling Inspection",
      icon: "🌡️",
      group: "Cooling Issues",
      description:
        "Inspect cooling issues, gas suspicion, airflow weakness, or performance drop.",
      basePrice: 299,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "ac-water-leakage",
      title: "AC Water Leakage Check",
      icon: "💧",
      group: "Cooling Issues",
      description:
        "Inspect leakage from indoor unit, pipe drainage issue, or related fitting problem.",
      basePrice: 299,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "ac-installation",
      title: "AC Installation",
      icon: "🧰",
      group: "Installation",
      description:
        "Install AC unit with fitting alignment and setup support. Final price depends on site and accessories.",
      basePrice: 1499,
      priceType: "starts_at",
      duration: "90-180 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "ac-uninstallation",
      title: "AC Uninstallation",
      icon: "🔁",
      group: "Installation",
      description:
        "Uninstall existing AC unit carefully for relocation or replacement.",
      basePrice: 699,
      priceType: "fixed",
      duration: "45-75 mins",
      warranty: "Service completion only",
      unit: "job",
    },
    {
      id: "ac-gas-check",
      title: "AC Gas / Performance Check",
      icon: "🧪",
      group: "Cooling Issues",
      description:
        "Inspection visit to assess refrigerant suspicion and cooling efficiency symptoms.",
      basePrice: 349,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default acRepairService;